import { Panel } from 'react-bootstrap'
import { IPendingSwap } from '@nkr/models/index';
import { FileDocumentType, PendingSwapsListType } from '@nkr/enums/index';
import { ICurrentTimeFrame, SwapsToShow } from '../models';
import { TableWrapper } from './styles'
import PendingSwapsRow from './pending-swaps-row';

interface IProps {
    list: IPendingSwap[],
    centerId: number,
    show: SwapsToShow,
    currentTimeframe: ICurrentTimeFrame,
    widths: string[],
    onRequestScreeningXm: (swap: IPendingSwap, existingXm: boolean, status: string) => void
    onRequestFinalXm: (swap: IPendingSwap, existingXm: boolean, status: string, isInternalOrRemote: boolean) => void,
    onEmergencyNotification: (swap: IPendingSwap) => void,
    onRequestSerologyKit: (swap: IPendingSwap, isInternalOrRemote: boolean) => void,
    onUploadFinalXm: (swap: IPendingSwap) => void,
    onUploadSerology: (swap: IPendingSwap) => void,
    onViewLogistics: (swap: IPendingSwap) => void,
    onShowMap: (url: string) => void,
    onShowGps: (link: string) => void,
    onViewCustomLogistics: (chainId: number, clusterNumber: number, positionNumber: number) => void
    onGetFinalXmResults: (recipientId: number, donorId: number, fileName: string) => void,
    onDownloadFormsAndChecklists: (donorId: number, recipientId: number) => void,
    onGetFile: (docType: FileDocumentType, donorId: number) => void,
    onGetPatientOutcomes: (centerId: number) => void,
    onViewCtScan: (donorId: number) => void
}

const Internals = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading style={{ fontSize: 16, fontWeight: 600 }}>
                Internal
            </Panel.Heading>
            <Panel.Body>
                <TableWrapper condensed>
                    <thead>
                        <tr style={{ backgroundColor: '#ddd' }}>
                            <th style={{ width: props.widths[0] }}>Swap Manager</th>
                            <th style={{ width: props.widths[0] }}>Swap Status</th>
                            <th style={{ width: props.widths[1] }}>Swap #</th>
                            <th style={{ width: '14%' }}>Donor</th>
                            <th style={{ width: '14%' }}>Patient</th>
                            <th style={{ width: props.widths[6] }}>Transplant<br />Date</th>
                            <th style={{ width: props.widths[7] }}>Tubes for<br />Transport</th>
                            <th style={{ width: props.widths[12] }}>{props.show == SwapsToShow.Pending ? 'Deadline' : ''}</th>
                            <th style={{ width: props.widths[11] }}></th>
                            <th style={{ width: props.widths[13] }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.map((swap, index) =>
                            <PendingSwapsRow
                                key={index}
                                index={index}
                                centerId={props.centerId}
                                data={swap}
                                type={PendingSwapsListType.Internal}
                                widths={props.widths}
                                show={props.show}
                                onRequestScreeningXm={props.onRequestScreeningXm}
                                onRequestFinalXm={props.onRequestFinalXm}
                                onEmergencyNotification={props.onEmergencyNotification}
                                onRequestSerologyKit={props.onRequestSerologyKit}
                                onViewLogistics={props.onViewLogistics}
                                onShowGps={props.onShowGps}
                                onShowMap={props.onShowMap}
                                onUploadFinalXm={props.onUploadFinalXm}
                                onUploadSerology={props.onUploadSerology}
                                onViewCustomLogistics={props.onViewCustomLogistics}
                                onGetFinalXmResults={props.onGetFinalXmResults}
                                onDownloadFormsAndChecklists={props.onDownloadFormsAndChecklists}
                                onGetFile={props.onGetFile}
                                onGetPatientOutcomes={props.onGetPatientOutcomes}
                                onViewCtScan={props.onViewCtScan}
                            />
                        )}

                        {props.list.length == 0 && props.show == SwapsToShow.Pending && (
                            <tr>
                                <td colSpan={10}>There are no internal swaps at this time...</td>
                            </tr>
                        )}

                        {props.list.length == 0 && props.show == SwapsToShow.Past && (
                            <tr>
                                <td colSpan={10}>There are no internal swaps for the {props.currentTimeframe.title.toLowerCase()}...</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </Panel.Body>
        </Panel>
    );
}

export default Internals;